import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../constants/app-constants';
import { InteractorResponse } from '../../models/interactor-response';
import { AbstractEntityService } from '../abstract/abstract-entity-service';
import { T22EntityItemDTO } from 'src/app/store/order/model';

const baseUrl = `/api/entities`;

@Injectable()
export class EntityService extends AbstractEntityService {
  private http = inject(HttpClient);

  getValuesByMask(entityId: number, mask: string): Observable<InteractorResponse<T22EntityItemDTO[]>> {
    return this.http.get<InteractorResponse<T22EntityItemDTO[]>>(`${baseUrl}/${entityId}/by-mask?mask=${mask ? mask : ''}`);
  }

  getAllValues(entityId: number): Observable<InteractorResponse<T22EntityItemDTO[]>> {
    return this.http.get<InteractorResponse<T22EntityItemDTO[]>>(`${baseUrl}/${entityId}`);
  }
}
